import { routeHead } from "@/lib/routeHead";
import { META_DESCRIPTIONS } from "@/lib/metaDescriptions";
import { createFileRoute } from "@tanstack/react-router";
import Researcher from "@/pages/Researcher";

export const Route = createFileRoute("/by/researcher")({
  head: () => routeHead('AGAPE Researcher — B2B-справаздача', META_DESCRIPTIONS.researcher.by, '/by/researcher'),
  component: Researcher,
});
